<div class="vertical-menu bay-sidebar">

  <!-- ── Logo ──────────────────────────────────────────────── -->
  <div class="bay-sidebar-logo">
    <a routerLink="/dashboard" class="bay-logo-link" *ngIf="ferme$ | async as ferme; else defaultLogo">
      <div class="bay-logo-icon" [class.bay-logo-icon--image]="logoCharge">
        <!-- Logo de la ferme (téléversé, sinon ancien logo de la fiche) ; icône tant qu'il n'est pas chargé -->
        <img *ngIf="!logoCharge" src="assets/images/wanar/wanar-signe.svg" alt="" class="bay-logo-wanar">
        <img [bayAuthSrc]="logoSrc$ | async" alt="" class="bay-logo-img" [class.d-none]="!logoCharge"
          (load)="logoCharge = true" (error)="logoCharge = false">
      </div>
      <span class="bay-logo-text">{{ ferme.nom || 'Wanar' }}</span>
    </a>
    <ng-template #defaultLogo>
      <a routerLink="/dashboard" class="bay-logo-link">
        <div class="bay-logo-icon bay-logo-icon--wanar">
          <img src="assets/images/wanar/wanar-signe.svg" alt="" class="bay-logo-wanar">
        </div>
        <span class="bay-logo-text">Wanar</span>
      </a>
    </ng-template>
  </div>

  <!-- ── Scroll area ────────────────────────────────────────── -->
  <ngx-simplebar class="bay-sidebar-scroll" #componentRef>

    <!-- Rôle Contenu : articles du site seulement -->
    <nav class="bay-sidebar-nav" *ngIf="estContenu">
      <a routerLink="/articles" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">article</span>
        Articles du site
      </a>
    </nav>

    <!-- Nav principal -->
    <nav class="bay-sidebar-nav" *ngIf="!estContenu">

      <a routerLink="/dashboard" routerLinkActive="snav-active"
         [routerLinkActiveOptions]="{exact: true}" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">home</span>
        Tableau de bord
      </a>

      <a *ngIf="voitModule('CULTURES')" routerLink="/maraichage" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">agriculture</span>
        Cultures
      </a>

      <a *ngIf="voitModule('CHEPTEL')" routerLink="/betail" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">pets</span>
        Cheptel
      </a>

      <!-- Pisciculture group -->
      <span *ngIf="voitModule('BASSINS')" class="bay-nav-label">Pisciculture</span>
      <a *ngIf="voitModule('BASSINS')" routerLink="/bassins" routerLinkActive="snav-active" class="snav-btn snav-sub">
        <span class="material-symbols-outlined snav-icon">water</span>
        Bassins
      </a>
      <a *ngIf="voitModule('BASSINS')" routerLink="/pisciculture" routerLinkActive="snav-active"
         [routerLinkActiveOptions]="{exact: true}" class="snav-btn snav-sub">
        <span class="material-symbols-outlined snav-icon">set_meal</span>
        Cohortes
      </a>

      <a *ngIf="voitModule('POULAILLER')" routerLink="/volaille" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">egg</span>
        Poulailler
      </a>

      <a routerLink="/taches" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">checklist</span>
        Tournées
      </a>

      <a routerLink="/stock" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">inventory_2</span>
        Stock
      </a>

      <a routerLink="/equipements" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">construction</span>
        Équipements
      </a>

      <a *ngIf="!estPersonnel && !limite" routerLink="/impact" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">volunteer_activism</span>
        Impact
      </a>

      <a routerLink="/journal" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">history</span>
        {{ estPersonnel || estContenu ? 'Mon activité' : 'Journal d\'activité' }}
      </a>

      <a *ngIf="voitValidations" routerLink="/validations" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">fact_check</span>
        Saisies à valider
        <span *ngIf="aValider > 0" class="badge rounded-pill ms-auto" style="background:#ba1a1a;color:#fff;">{{ aValider }}</span>
      </a>

      <a *ngIf="!estPersonnel" routerLink="/finances" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">payments</span>
        {{ libelleFinances }}
      </a>

      <a *ngIf="!estPersonnel && !limite" routerLink="/factures" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">receipt_long</span>
        Factures
      </a>

      <a *ngIf="!estContenu" routerLink="/galerie" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">photo_library</span>
        Galerie
      </a>

      <a *ngIf="!limite" routerLink="/ged" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">folder_open</span>
        Documents
      </a>

      <div class="bay-nav-divider"></div>

      <a routerLink="/farm-map" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">map</span>
        Carte ferme
      </a>

      <a *ngIf="!estPersonnel && !limite" routerLink="/statistiques" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">bar_chart</span>
        Statistiques
      </a>

      <a *ngIf="voitAnalyste" routerLink="/analyste" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">insights</span>
        Analyste
      </a>

      <a *ngIf="voitArticles" routerLink="/articles" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">article</span>
        Articles du site
      </a>

      <a *ngIf="!estPersonnel && !limite" routerLink="/partenaires" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">handshake</span>
        Partenaires
      </a>

      <a *ngIf="!estPersonnel" routerLink="/contacts-crm" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">contacts</span>
        CRM Contacts
      </a>

    </nav>

    <!-- Bottom : atelier + utilisateurs + déconnexion -->
    <div class="bay-sidebar-bottom">
      <ng-container *ngIf="!estContenu">
      <a *ngIf="!estPersonnel && !limite" routerLink="/fermes" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">cottage</span>
        Ma ferme
      </a>
      <a *ngIf="!estPersonnel" routerLink="/types-animaux" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">category</span>
        Types animaux
      </a>
      <a *ngIf="!estPersonnel" routerLink="/users" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">group</span>
        Utilisateurs
      </a>
      <a *ngIf="!estPersonnel && !limite" routerLink="/abonnement" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">workspace_premium</span>
        Mon abonnement
      </a>
      <a *ngIf="superAdmin" routerLink="/plateforme/abonnements" routerLinkActive="snav-active" class="snav-btn">
        <span class="material-symbols-outlined snav-icon">admin_panel_settings</span>
        Plateforme
      </a>
      </ng-container>
      <button class="snav-btn snav-logout" (click)="logout()">
        <span class="material-symbols-outlined snav-icon">logout</span>
        Déconnexion
      </button>
    </div>

  </ngx-simplebar>
</div>
